export default __webpack_public_path__ + "static/media/ProfileDark.3b7af9cf.svg";